export default class Controller {
    static get $inject() {
        return ['$uibModalInstance', '$scope'];
    }

    constructor($uibModalInstance, $scope) {

        this.$uibModalInstance = $uibModalInstance;
        $scope.ok = (userCode) => {
            this.$uibModalInstance.close(userCode);
        }

    }

}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/userCode/controller.js
 **/